import React from 'react';

import { SCCUniversalDevice } from '@/comp/StationControlCenter/types/universal-device.types';
import { MetricItem } from '../Metrics/MetricItem/MetricItem';
import { MetricVM } from '../Metrics/MetricItem/MetricItem.types';
import { ContentWithSlider } from './ContentWithSlider/ContentWithSlider';
import { ContentWithoutSliderContainer } from './ContentWithoutSlider/ContentWithoutSlider.styles';
import { AlertsBar } from './AlertsBar/AlertsBar';
import { ContentContainer } from './Content.styles';

interface ContentProps {
  hasBar: boolean;
  device: SCCUniversalDevice;
  metrics: MetricVM[];
  activeOpenAlerts: unknown[];
}

export const Content = ({
  hasBar,
  device,
  metrics,
  activeOpenAlerts,
}: ContentProps) => {
  return (
    <ContentContainer>
      {hasBar ? (
        <ContentWithSlider device={device}/>
      ) : (
        <ContentWithoutSliderContainer>
          {metrics.map(metric => (
            <MetricItem
              key={metric.id}
              variant="content"
              label={metric.label}
              value={metric.value}
              unit={metric.unit}
            />
          ))}
        </ContentWithoutSliderContainer>
      )}

      <AlertsBar activeOpenAlerts={activeOpenAlerts} />
    </ContentContainer>
  );
};
